import React from "react"
import { extractValueFromString } from "./customSort";

export function arrangePropsForTables(data, colHeaders){
  
  let scopedSlots = {}
  for (let [index, header] of colHeaders.entries()) {
    scopedSlots = {
      ...scopedSlots,
      [header]: item=>{
        let row = data.find(rowArray=> rowArray[0].trim() === item["LOCATION"])[index]
        return <td><div dangerouslySetInnerHTML={{__html: row}}/></td>
      }
    }
  }

  let formattedData = data.map(rowArray=>{
    return rowArray.map(rowItem=>{
      return extractValueFromString(rowItem)
    })
  })
  
  return {
    table: {data: formattedData, colHeaders},
    tableFilter: false,
    sorter: true,
    pagination: false,
    scopedSlots
  }
}
